import React from 'react'
import { Card, Typography, Col, Button } from 'antd'
import { useHistory } from 'react-router-dom'
import { SVGIcon } from 'components/elements'

const { Title } = Typography

const InsufficientPermissions = ({ showCard = true }) => {
  const history = useHistory()

  const body = (
    <div
      style={{ minHeight: 'calc(100vh - 195px)' }}
      className="t-flex t-items-center t-justify-center"
    >
      <div className="ant-result ant-result-404">
        <SVGIcon />
        <div className="ant-result-title">Insufficient Permissions</div>
        <div className="ant-result-subtitle">
          Role assigned to the user does not have permissions to perform the
          requested operation
        </div>
        <div className="ant-result-extra">
          <Button onClick={() => history.push('/')} type="primary" size="small">
            Back Home
          </Button>
        </div>
      </div>
    </div>
  )

  return showCard ? (
    <Card
      className="header-solid"
      bordered={false}
      title={[
        <Col>
          <Title level={4}>Error 403</Title>
        </Col>,
      ]}
    >
      {body}
    </Card>
  ) : (
    body
  )
}

export { InsufficientPermissions }
